// Web端图片
import webImg1 from '@/assets/images/about/about_awards_web_img1.png'
import webImg2 from '@/assets/images/about/about_awards_web_img2.png'
import webImg3 from '@/assets/images/about/about_awards_web_img3.png'
import webImg4 from '@/assets/images/about/about_awards_web_img4.png'
import webImg5 from '@/assets/images/about/about_awards_web_img5.png'
import webImg6 from '@/assets/images/about/about_awards_web_img6.png'
import webImg7 from '@/assets/images/about/about_awards_web_img7.png'
import webImg8 from '@/assets/images/about/about_awards_web_img8.png'
import webImg9 from '@/assets/images/about/about_awards_web_img9.png'
import webImg10 from '@/assets/images/about/about_awards_web_img10.png'
import webImg11 from '@/assets/images/about/about_awards_web_img11.png'
import webImg12 from '@/assets/images/about/about_awards_web_img12.png'
import webImg13 from '@/assets/images/about/about_awards_web_img13.png'
import webImg14 from '@/assets/images/about/about_awards_web_img14.png'
import webImg15 from '@/assets/images/about/about_awards_web_img15.png'
import webImg16 from '@/assets/images/about/about_awards_web_img16.png'
import webImg17 from '@/assets/images/about/about_awards_web_img17.png'

// 移动端图片
import mobileImg1 from '@/assets/images/about/about_awards_mobile_img1.png'
import mobileImg2 from '@/assets/images/about/about_awards_mobile_img2.png'
import mobileImg3 from '@/assets/images/about/about_awards_mobile_img3.png'
import mobileImg4 from '@/assets/images/about/about_awards_mobile_img4.png'
import mobileImg5 from '@/assets/images/about/about_awards_mobile_img5.png'
import mobileImg6 from '@/assets/images/about/about_awards_mobile_img6.png'
import mobileImg7 from '@/assets/images/about/about_awards_mobile_img7.png'
import mobileImg8 from '@/assets/images/about/about_awards_mobile_img8.png'
import mobileImg9 from '@/assets/images/about/about_awards_mobile_img9.png'
import mobileImg10 from '@/assets/images/about/about_awards_mobile_img10.png'
import mobileImg11 from '@/assets/images/about/about_awards_mobile_img11.png'
import mobileImg12 from '@/assets/images/about/about_awards_mobile_img12.png'
import mobileImg13 from '@/assets/images/about/about_awards_mobile_img13.png'
import mobileImg14 from '@/assets/images/about/about_awards_mobile_img14.png'
import mobileImg15 from '@/assets/images/about/about_awards_mobile_img15.png'
import mobileImg16 from '@/assets/images/about/about_awards_mobile_img16.png'
import mobileImg17 from '@/assets/images/about/about_awards_mobile_img17.png'

export const useAwardImages = () => {
  const webImages = [
    webImg1,
    webImg2,
    webImg3,
    webImg4,
    webImg5,
    webImg6,
    webImg7,
    webImg8,
    webImg9,
    webImg10,
    webImg11,
    webImg12,
    webImg13,
    webImg14,
    webImg15,
    webImg16,
    webImg17,
  ]

  const mobileImages = [
    mobileImg1,
    mobileImg2,
    mobileImg3,
    mobileImg4,
    mobileImg5,
    mobileImg6,
    mobileImg7,
    mobileImg8,
    mobileImg9,
    mobileImg10,
    mobileImg11,
    mobileImg12,
    mobileImg13,
    mobileImg14,
    mobileImg15,
    mobileImg16,
    mobileImg17,
  ]

  return { webImages, mobileImages }
}
